import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthService } from "services/AuthService";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import EmailVerificationCard from "./emailVerificationCard";
import { OtpType } from "enum/OtpType";
import { AuthData, useAuth } from "context/AuthProvider";
import { UserTypes } from "enum/UserTypes";

const EmailVerification: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, , , , refreshUser] = useAuth() as AuthData;

  document.title = "User Verification | Zulu Courier ";

  const handleSubmit = (otp: string) => {
  
    
    AuthService.emailOTPVerification({ email: location.state?.email, otpCode: otp })
      .then(async res => {
        if (res.success) {
          AuthService.setToken(res.data);
          const refreshedUser = await refreshUser();
          const data: any = jwt_decode(res.data);
          const userRole = refreshedUser?.role || data?.user_role;

          if (userRole === UserTypes.BUSINESS_CUSTOMER || userRole === UserTypes.PERSONAL_CUSTOMER) {
            navigate(`/${userRole}/place-orders`, { replace: true });
          } else {
            toast.error("Account verified, but we could not find a valid customer dashboard route.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: {marginBottom: "4rem"},
            });
          }
        } else {
          toast.error(res.error, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: {marginBottom: "4rem"},
          });
        }
      })
      .catch(error => {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: {marginBottom: "4rem"},
        });
      });
  };

  const resendOtp = () => {
    AuthService.resendOtp({ email: location.state?.email, otpType: OtpType.SIGNUP_OTP})
      .then(res => {
        if (res.success) {
          toast.success(res.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: {marginBottom: "4rem"},
          });
        } else {
          toast.error(res.error, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: {marginBottom: "4rem"},
          });
        }
      })
      .catch(error => {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: {marginBottom: "4rem"},
        });
      });
  };

  return (
    <EmailVerificationCard email={location.state?.email} onSubmit={handleSubmit} onResendOtp={resendOtp} />
  );
};

export default EmailVerification;
